import React from "react";
import { evaluateFieldLength } from "../../utils/coverLetterFieldLimits";

/**
 * FieldLengthHint — soft inline guidance for PDF-bounded form fields.
 *
 * Renders ONLY when the field is in the limits config. Otherwise
 * returns null so it can be sprinkled everywhere without harm.
 *
 * Props:
 *   field: string — key in coverLetterFieldLimits (e.g. "full_name")
 *   value: string — the current input value
 */
const FieldLengthHint = ({ field, value }) => {
  const result = evaluateFieldLength(field, value);
  if (!result) return null;
  const { count, max, zone, note } = result;

  const COLOR = {
    green: "text-slate-400",
    amber: "text-amber-600",
    red: "text-red-600 font-semibold",
  }[zone];

  const MESSAGE = {
    green: note || "",
    amber: "Tight — the PDF may shrink this to fit.",
    red: "Too long — will be truncated or shrunk on the printed PDF.",
  }[zone];

  return (
    <div
      className={`flex justify-between items-center text-[11px] mt-0.5 ${COLOR}`}
      data-testid={`field-length-hint-${field}`}
      data-zone={zone}
    >
      <span className="truncate pr-2">{MESSAGE}</span>
      <span className="tabular-nums shrink-0" aria-label="character count">
        {count} / {max}
      </span>
    </div>
  );
};

export default FieldLengthHint;
